import { useCallback, useMemo } from "react";

import { useRecoilState, useSetRecoilState } from "recoil";
import { Button, ICountries, Input } from "@storybook";

import { FacialDataState, LoginPhoneNumberState, SignInActiveStep } from "states";

import style from "./signin-form.module.sass";
import "./signin-form.scss";
import { Face, useNetwork } from "hooks";

export const SignInForm = () => {
  const setFacialData = useSetRecoilState(FacialDataState)
  const setSignInActiveStep = useSetRecoilState(SignInActiveStep);

  const [loginPhoneNumber, setLoginPhoneNumber] = useRecoilState(
    LoginPhoneNumberState
  );

  const { post } = useNetwork();

  const handleOnClick = useCallback(() => {
    setSignInActiveStep("chooseMethod");
    post("/biometrics/get", loginPhoneNumber).then((data) => {
        const { descriptors, name } = data ?? {};
        if (descriptors && name) {
          setFacialData(data);
          Face.setupFacialRecoganization({
            facialData: data,
            label: name,
            descriptors,
          });
          Face?.facialInit().then(() => {
            console.log("Face loaded");
          })
        } else {
          setFacialData({});
          Face.setupFacialRecoganization({
            facialData: {},
            label: "",
            descriptors: [],
          });
        }
      }).catch(err => {
        console.log("Error", err)
        setFacialData({});
        Face.setupFacialRecoganization({
          facialData: {},
          label: "",
          descriptors: [],
        });
      });
  }, [loginPhoneNumber, post, setFacialData, setSignInActiveStep]);

  const onHandleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement> | any) => {
      const { value } = e.target;
      const re = /^[0-9\b]+$/;
      //accept only number and value ==='' is used as first char should be remove in input field
      if (re.test(value) || value === "") {
        setLoginPhoneNumber((prevState) => {
          const newState = { ...prevState, phone: value };
          return newState;
        });
      }

      if (e.keyCode === 13) {
        handleOnClick();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleCountryCode = useCallback((e: ICountries) => {
    const value = e.label;
    setLoginPhoneNumber((prevState) => {
      const newState = { ...prevState, countryCode: value };
      return newState;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isDisabled = useMemo(() => {
    if (loginPhoneNumber?.phone.length > 5) return false;
    return true;
  }, [loginPhoneNumber]);

  return (
    <div className={style.wrapper}>
      <div className={style.inner_wrapper}>
        <div className={style.inner}>
          <div>
            <div className={style.title}>Enter Your Mobile Number</div>
            <div className={style.sub_title}>
              We will send you a connection request into your Mobile app.
            </div>
          </div>

          <form className={style.form_wrapper} autoComplete="on">
            <div className={`${style.input_wrapper} input-wrapper`}>
              <Input
                handleChange={onHandleChange}
                inputType="text" //keet type text as number is not giving suggestions for auto fill will use regex to accept number
                value={loginPhoneNumber.phone}
                placeholder="XXXXXXXXXX"
                label=""
                handleChangeCountry={handleCountryCode}
                isCountryCodeVisible={true}
                countryCode={loginPhoneNumber.countryCode as string}
                autoComplete="tel"
                inputName="phone"
              />
            </div>

            <Button
              type={"button__filled--primary button__large button__block"}
              handleClick={handleOnClick}
              label="Login"
              disabled={isDisabled}
            />
          </form>
        </div>
      </div>
    </div>
  );
};
